import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cart-confirmation-modal',
  templateUrl: './cart-confirmation-modal.component.html',
  styleUrls: ['./cart-confirmation-modal.component.scss']
})
export class CartConfirmationModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
